import {
  SCHEDULE_LIST
} from 'containers/Project/ScheduleSection/constants'

export const MODULE_NAME = 'fulcrum/container/project/specifications'
export const UPDATE_ORIGINAL_REVISION = 'fulcrum/container/project/specifications/UPDATE_ORIGINAL_REVISION'
export const UPDATE_MODIFIED_REVISION = 'fulcrum/container/project/specifications/UPDATE_MODIFIED_REVISION'

export const TABS = {
  MODIFICATION: 'modification',
  SPECIFICATION: 'specification',
  HISTORY: 'history',
}

export const MODULES = [
  'schedule',
  'project',
  'max_pq',
  'system',
  'system_management_and_firmware',
  'mission_profile',
  'configuration',
  'system_software',
  'baseboard',
  'baseboard_power',
  'baseboard_power_components',
  'cpu',
  'cpu_details',
  'panel',
  'clock',
  'pcb',
  'pcb_stackup',
  'pcie',
  'input_connector',
  'power',
  'power_monitor_ic',
  'voltage_regulator',
  'power_components',
  'battery',
  'thermal',
  'system_configuration',
  'cpu_root_port',
  'mechanical',
  'display',
  'display_connector',
  'memory',
  'nic',
  'pcie_switch_retimer',
  'memory_storage_device',
  'high_current_device',
  'lc_voltage_regulator_device',
  'fsi_interface',
  'peripheral_interface_spi',
  'peripheral_interfaces_i_2_c',
  'fsync_signal',
  'pwm',
  'uart',
  'peripheral_interfaces_dap',
  'peripheral_interfaces_can',
  'peripheral_interfaces_eth',
  'peripheral_interfaces_usb_2',
  'peripheral_interfaces_usb_3',
  'peripheral_interfaces_pcie',
  'display_hdmi',
  'camera_video_input',
  'system_ethernet_switch',
  'thermal_interface_material_detail',
  'system_saftey_mcu',
  'product_storage',
  'hgx_product_storage',
  'system_management',
  'nvlink_bridge',
  'system_power_supply',
  'io_switch_board',
  'project_feature',
]

export const SPEC_ORDER = {
  schedule: SCHEDULE_LIST,
  project: [
    'project_name',
    'odm_name',
    'form_factor',
    'project_restricted',
    'project_ssid',
    'project_svid',
    'gam_approval_id',
    'target_application',
    'external_source',
    'contract_start',
    'contract_end'
  ],
  configuration: [
    'nvidia_soc_product',
    'configuration_use_case',
    'cpu_speed',
    'gpu_speed',
    'pva_speed',
    'dla_speed',
    'low_power_mode_suspend_trigger',
    'low_power_mode_wake_trigger'
  ],
  other: [
    'waterproof_rating',
    'boot_time_kpi'
  ],
  strapping: [
    'ram_code',
    'boot_select',
    'boot_chain'
  ],
  max_pq: [
    'max_pq',
    'max_pq_certification_participation',
    'max_pq_platform_power_aware_gpu_boost',
    'max_pq_platform_power_aware_gpu_boost_dc',
    'max_pq_configurable_tgp_mode',
    'max_pq_configurable_tgp_value',
    'tgp_offset'
  ],
  system: [
    'system_model_name',
    'system_form_factor',
    'system_rack_unit',
    'system_memory',
    'system_memory_module_type',
    'system_memory_configuration',
    'system_storage',
    'system_pcie_speed',
    'system_pcie_width',
    'chipset',
    'chassis_length',
    'chassis_width',
    'chassis_height',
    'system_cpu_tdp',
    'system_jbog',
    'gpu_memory_size',
    'system_memory_size',
    'system_cpu_count',
    'system_gpu_count',
    'gpu_frequency',
    'mgx_compliant',
    'gpu_count_per_baseboard',
    'system_pcie_max_depth',
    'system_nvlink_bridge',
    'system_nvlink_topology',
    'system_nvlink_speed',
    'gpu_tray_height',
    'system_notes',
    'max_vin_batt',
    'min_vin_batt',
    'pressure_on_lid',
    'reference_design',
    'node_count_chassis',
    'chassis_dimensions',
    'pcb_layers',
    'gpu_count'
  ],
  system_software: [
    'os_version',
    'system_software',
    'gpu_driver_version',
  ],
  system_management_and_firmware: [
    'management_board_details',
    'bmc_vendor_pn',
    'bmc_fw_vendor',
    'lan_on_motherboard',
    'bios_vendor',
    'system_management_interface'
  ],
  baseboard: [
    'baseboard_count',
    'baseboard_input_voltage',
    'module_voltage_min', 
    'module_voltage_max'
  ],
  baseboard_power: [
    'baseboard_power_total',
  ],
  baseboard_power_components: [
    'component',
    'power'
  ],
  panel: [
    'size',
    'resolution', // custom
    'refreshRate',
    'vendorName',
    'partNumber',
  ],
  clock: [
    'ocBin',
    'vfOffset',
    'baseClock',
    'boostClock',
    'tgp',
  ],
  pcb: [
    'pcb_length',
    'pcb_height',
    'pcb_width',
    'pcb_thickness',
    'pcb_material',
    'pcb_technology',
    'pcb_stackup',
    'pcb_layer',
    'pcb_class',
    'pcb_comments'
  ],
  pcie: [
    'pcie_speed',
    'pcie_width'
  ],
  input_connector: [
    'connectorCount',
    'pinCount',
  ],
  power: [
    'power_tdp',
    'tgp_max',
    'power_tgp_max',
    'power_tgp_rated',
    'power_tcp_rated',
    'power_tmp_rated',
    'tsp_design',
    'max_pq',
    'max_pq_certification_participation',
    'max_pq_platform_power_aware_gpu_boost',
    'max_pq_platform_power_aware_gpu_boost_dc',
    'max_pq_configurable_tgp_mode',
    'max_pq_configurable_tgp_value',
    'tgp_offset',
    'shipping_tgp',
    'max_tgp'
  ],
  power_monitor_ic: [
    'type',
    'vendor',
    'partNumber',
    'details'
  ],
  battery: [
    'battery_size',
    'battery_tgp',
    'battery_discharge_rate',
    'battery_ac_adapter_wattage',
    'battery_ac_adapter_voltage',
    'battery_ac_adapter_size'
  ],
  thermal: [
    'thermal_cooler_type',
    'thermal_capacity',
    'thermal_cpu_capacity',
    'thermal_gpu_capacity',
    'thermal_cooler_topology',
    'qboost_budget',
    'thermal_acoustic_temperature_limit',
    'thermal_cooler_design_source',
    'thermal_fan_type',
    'thermal_fan_connector',
    'thermal_fan_count',
    'thermal_fan_cooler_contact',
    'thermal_flow_rate',
    'thermal_airflow_direction',
    'hgx_thermal_airflow_direction',
    'thermal_airflow_cfm',
    'thermal_airflow_inlet_temperature',
    'thermal_airflow_inlet_max_temperature',
    'thermal_cooler_vendor',
    'thermal_interface_material',
    'tim_2_bond_line_thickness',
    'tim_3_bond_line_thickness',
    'thermal_liquid_flow_direction',
    'thermal_liquid_flow_rate',
    'thermal_reference_type',
    'thermal_heatpipe',
    'thermal_stackup',
    'thermal_average_pressure',
    'gpu_target_temperature_thermal_simulation',
    'thermal_solution',
    'inlet_temperature',
    'flow_rate',
    'max_ambient_temperature',
    'max_ecu_ambient_temperature',
    'min_ecu_ambient_temperature',
    'soc_tdp',
    'ecu_tdp',
    'soc_subsystem_max',
    'ecu_max_power',
    'low_power_mode_support',
    'thermal_solution_running_sc',
    'thermal_solution_running_key_off',
  ],
  mechanical: [
    'mechanical_top_z_height',
    'mechanical_bottom_z_height',
    'total_card_dimension_x',
    'total_card_dimension_y',
    'total_card_dimension_z'
  ],
  display: [
    'advanced_optimus',
    'display_ms_hybrid_mode',
    'display_discrete_mode_no_edp_mux',
    'display_edp_mux_part_number',
  ],
  display_connector: [
    'linkType',
    'connectorType',
    'connectorSource',
    'connectorLocation',
    'connectorFeature',
    'connectorBracket',
  ],
  default_cpu: [
    'architecture',
    'brand',
    'classification',
    'modelName',
  ],
  cpu: [
    'architecture',
    'brand',
    'classification',
    'modelName',
  ],
  cpu_details: [
    'cpu_frequency',
    'cpu_core_count',
    'baseboard_cpu_tdp',
    'system_cpu_pcie_link',
  ],
  cpu_root_port: [
    'portNumber',
    'portConfiguration'
  ],
  voltage_regulator: [
    'railType',
    'partType',
    'phaseCount',
    'vendorName',
    'partNumber',
    'efficiency'
  ],
  power_components: [
    'railType',
    'componentType',
    'componentPart',
    'componentDetails',
  ],
  memory: [
    'density',
    'memConfig', // custom
    'clock',
    'item' // custom
  ],
  nic: [
    'nicVendor',
    'nicSpeed',
    'nicCount',
    'nicProtocolType'
  ],
  system_configuration: [
    'tpm',
    'rtc',
    'nvme_hot_plug_support',
    'cable_cartridges_and_nvlink_switch',
    'compute_motherboard',
    'compute_tray_configuration',
    'rack_type',
    'rack_height'
  ], 
  system_management: [
    'system_management_interface',
  ],
  pcie_switch_retimer: [
    'vendor',
    'partNumber',
    'count',
    'details'
  ],
  high_current_device: [
    'device',
    'quantity',
    'vendor',
    'partNumber',
    'outputVoltage'
  ],
  lc_voltage_regulator_device: [
    'device',
    'vendor',
    'partNumber',
    'outputVoltage'
  ],
  fsi_interface: [
    'device',
    'initiator',
    'interfaceFrequency',
    'mode',
    'vendor',
    'partNumber'
  ],
  peripheral_interface_spi: [
    'portNumber',
    'initiator',
    'spiMode',
    'interfaceFrequency',
    'vendorOne',
    'partNumberOne',
    'vendorTwo',
    'partNumberTwo'
  ],
  memory_storage_device: [
    'device',
    'memoryType',
    'memorySize',
    'busWidth',
    'maxFrequency',
    'runningFrequency',
    'vendor',
    'partNumber',
    'maxTemperature',
    'refreshRate'
  ],
  peripheral_interfaces_i_2_c: [
    'portNumber',
    'initiator',
    'interfaceFrequency',
    'device',
    'deviation'
  ],
  fsync_signal: [
    'item',
    'interfaceFrequency',
    'vendor',
    'partNumber'
  ],
  pwm: [
    'portNumber',
    'interfaceFrequency',
    'vendor',
    'partNumber'
  ],
  uart: [
    'portNumber',
    'interfaceFrequency',
    'vendor',
    'partNumber'
  ],
  peripheral_interfaces_dap: [
    'portNumber',
    'initiator',
    'dapMode',
    'dapIo',
    'interfaceFrequency',
    'vendor',
    'partNumber'
  ],
  peripheral_interfaces_can: [
    'portNumber',
    'canMode',
    'vendor',
    'partNumber'
  ],
  peripheral_interfaces_eth: [
      'item',
      'portNumber',
      'speed',
      'vendor',
      'partNumber'
  ],
  peripheral_interfaces_usb_2: [
      'portNumber',
      'hostDevice',
      'interfaceFrequency',
      'connector',
      'vendor',
      'partNumber'
  ],
  peripheral_interfaces_usb_3: [
      'controllerNumber',
      'hostDevice',
      'interfaceFrequency',
      'connector',
      'vendor',
      'partNumber'
  ],
  peripheral_interfaces_pcie: [
      'controllerNumber',
      'pcieMode',
      'numberLanes',
      'interfaceFrequency',
      'connector',
      'vendor',
      'partNumber'
  ],
  display_hdmi: [
    'mstSupport',
    'displayMode',
    'serializerVendor',
    'serializerPartNumber',
    'serializerBandwidth',
    'header',
    'dpAux',
    'initiator',
    'inferfaceFrequency',
    'deviceVendor',
    'partNumber'
  ],
  camera_video_input: [
    'portNumber',
    'csiGroup',
    'csiMode',
    'numberOfLanes',
    'deserializerVendor',
    'deserializerPartNumber',
    'deserializerInstanceNumber',
    'estimatedTotalBandwidth'
  ],
  system_saftey_mcu: [
    'deviceVendor',
    'devicePartNumber',
    'interface'
  ],
  system_ethernet_switch: [
    'vendor',
    'partNumber',
    'port'
  ],
  thermal_interface_material_detail: [
    'layer',
    'materialDetails',
    'bondlineThickness',
    'timThickness',
    'dispensingPattern',
    'volume'
  ],
  product_storage: [
    'storageType',
    'count',
    'details',
  ],
  hgx_product_storage: [
    'storageType',
    'count',
    'details',
  ],
  mission_profile: [
    'vehicleType',
    'serviceLife',
    'powerOnHours',
    'powerOffHours',
    'mileage',
    'powerOnOffCycles',
    'powerOn',
    'powerOff'
  ],
  nvlink_bridge: [
    'nvlink_bridge_mechanism',
    'nvlink_board_material',
    'nvlink_board_manufacturer'
  ],
  
  system_power_supply: [
    'system_power_supply_config',
    'system_power_source',
    'psu',
    'power_supply_config',
    'redundancy_configuration',
    'psu_vendor_pn',
    'psu_input_voltage',
    'psu_output_voltage',
    'psu_wattage',
    'system_total_power'
  ],
  io_switch_board: [
    'io_switch_board_config'
  ]
}

export const NESTED_SPEC_ORDER = {
  peripheral_interfaces_i_2_c: {
    device: [
      'vendor',
      'partNumber',
      'address',
      'voltageLevel'
    ]
  },
  display_hdmi: {
    header: [
      'headerNumber',
      'horizontalResolution',
      'verticalResolution',
      'pixelFormat',
      'frameRate',
    ]
  },
  system_ethernet_switch: {
    port: [
      'portNumber',
      'configuration',
      'speed',
      'phy',
      'connection',
    ]
  },
  system_saftey_mcu: {
    interface: [
      'interfaceName',
      'comments'
    ]
  }
}

export const LINK_TYPE_ORDER = [ 'A', 'B', 'C', 'D', 'E', 'F' ]
export const CONNECTOR_TYPE_ORDER = [ '6pin PCIe', '8pin PCIe', '8pin CPU' ]

export const FILTER_ALL = 'all'
export const FILTER_RISK = 'risk'
export const FILTER_MODIFIED = 'modified'
export const SELECT_FILTER = 'fulcrum/containers/Project/Specifications/SELECT_FILTER'
